declare var cmn_schemeName: string;
declare var cmn_cartDomain: string;
declare function GetCustomerName();

const HOST_URL = location.host;
const RUN      = ['system.ishiharakaori-fc.com'];

// クエリパラメータを取得
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const paramFcm = urlParams.get('fcm');


$(function () {
    let $body = $('body');
    let bodyId = $body.attr('id');

    if (bodyId === 'Register') {
        pageRegister();
    } else if (bodyId === 'RegisterStep1') {
        RegisterStep1();
    } else if (bodyId === 'MyPage') {
        MyPage();
    } else if (bodyId === 'fc_help') {
        // ご利用ガイド
        fcHelp()
    } else if (bodyId === 'Login') {
        // ログイン
        login()
    } else if(bodyId == 'CustomerEdit') {
        //会員情報変更
        CustomerEdit();
    } else if (bodyId === 'CustomerEditFin') {
        CustomerEditFin();
    } else if(bodyId == 'fc_contact') {
        // お問い合わせ
        fcContact();
    } else if (bodyId == 'fcJoin') {
        fcJoin();
    } else if (bodyId == 'fcJoinMail') {
        fcJoinMail();
    } else if (bodyId === 'fcJoinMailSend') {
        fcJoinMailSend();
    } else if (bodyId === 'fcJoinEntry') {
        fcJoinEntry()
    } else if (bodyId == 'fcJoinConf') {
        fcJoinConf();
    } else if (bodyId == 'fcJoinThk') {
        fcJoinThk();
    }

    // ログイン済の場合、bodyにclassを付与する
    // 入会完了ページではclassを付けない
    if(bodyId != 'fcJoinThk' && GetCustomerName()) {
        $('body').addClass('aem-logined');
    }

    // フッターのプライバシーポリシーのリンク先を変える
    setTimeout(function(){
        $('#cmnfoot_button_privacy').attr('href', 'https://www.ponycanyon.co.jp/privacy_policy');
        $('#cmnfoot_button_privacy').attr("target","_blank");
    }, 100);
});

// Register
function pageRegister() {
    // $('.tblbody_email .table_control').prepend('<div class="mb-20"><a href="" target="_blank">【利用規約】</a>にご同意の上、メールアドレスを入力してください。</div>');
}

// RegisterStep1
function RegisterStep1() {
    // $('.table_label.col_must').each(function(){
    //     let $title = $(this);

    //     if($title.text().indexOf('郵便番号') > -1) {
    //         $title.append('<div class="c-red">※ハイフンなしの半角数字で入力してください。</div>');
    //     }
    // });
}

// MyPage
function MyPage() {

    // タイトルを置換
    $('.t_title').text('MYPAGE');

    // アコーディオンを開いておく
    $('.table_collapse_link').removeClass('collapsed').attr('aria-expanded', 'true');
    $('.glyphicon').removeClass('glyphicon-chevron-left').addClass('glyphicon-chevron-down');
    $('.table_collapse').addClass('in');

    // ニックネームのいちを変える
    var $clone = $('#panel_costomer').find('.freeitem_box_258').clone();
    $('#panel_costomer .tblbody_name').after($clone);

    var len = $('#panel_costomer').find('.freeitem_box_258').length;
    $('#panel_costomer').find('.freeitem_box_258').each(function(index){
        if(index == len - 1) {
            $(this).remove();
        }
    });
}

// ご利用ガイド
function fcHelp() {

    // タイトルを置換する
    $('.t_title').text('よくある質問');
}

// ログイン
function login() {
    // ログイン方法に関する重要なお知らせを消す
    $('.fc_register_table').hide();

    // ログインのボタン名を置換
    setTimeout(function(){
        $('#LoginBtn').val('LOGIN');
    }, 300);

    // 新規会員登録ボタンのリンク先を変更
    setTimeout(function(){
        $('#fcJoin_lnk').attr('href', 'https://ishiharakaori-fc.com/about/register_info.php');
    }
    , 100);
}

function fcJoinEntry() {
    // 自動継続更新のチェックボクスをonにする
    // $('#card_fc_auto').prop('checked', true);

    $('#step_fcjoin_01 .t_title').text('3.会員情報を入力');

    // ニックネームの属性に最大値を設置する
    $('input[name="freeitemid_258"]').attr('maxlength', '20');
    $('input[name="freeitemid_258"]').after('<span class="text-danger">※20文字以内</span>');

    // 手数料の文言を変える
    $('.tblbody_feeamount .table_control').text('（金額は次ページにてご確認ください。）');
}

function CustomerEdit() {
    // ニックネームの属性に最大値を設置する
    $('input[name="freeitemid_258"]').attr('maxlength', '20');
    $('input[name="freeitemid_258"]').after('<span class="text-danger">※20文字以内</span>');
}

function fcContact() {
    $('#fc_contact .t_message').each(function(index){
        // お電話でのお問い合わせを非表示にする
        if(index == 0) {
            $(this).hide();
        }
    })
}

function fcJoin() {
    $('#step_fcjoin_01 .t_title').text('1.会員規約を確認');
}

function fcJoinMail() {
    $('#step_fcjoin_01 .t_title').text('2.メールアドレスを入力');
    $('#fcm_name_txt').text('石原夏織 オフィシャルファンクラブ「hand in hand」 ご入会希望の方は、下記よりメールアドレスをご入力ください。');

    const copy = $('.table_control .message_area .text-danger').clone();
    $('.table_control .message_area')
        .html('※ご指定のメールアドレス宛にファンクラブ入会手続きのご案内メールを送信いたします。<br>※ご案内メールの中に記述されたURLにアクセスして新規入会手続きを行ってください。')
        .append(copy);
}

function fcJoinMailSend() {
    $('#step_fcjoin_01 .t_title').text('メール送信完了');
    const text = $('.alert-success').html().replace('おこなって', '行って');
    $('.alert-success').html(text);
}

function fcJoinConf() {
    $('#step_fcjoin_01 .t_title').text('4.登録情報を確認');
}

function fcJoinThk() {
    $('#step_fcjoin_01 .t_title').text('5.お申込み完了');

    // 年額のみコンビニ支払いの注意書きを追加
    if (paramFcm && paramFcm !== 'IHKM') {
        $('.alert-success').append('<br><br><span class="alert-success--c-red">※コンビニ支払いをご選択の方は、入金後に入会完了となります。支払期間中のご対応をお願いいたします。</span>');
    }
}

function CustomerEditFin() {
    $('.alert-success').html('会員情報を変更しました。');
}

// アコーディオン
$(function () {

    // クラス名定義
    var accordionTitleClass = 'js-accordion-title';
    var accordionBodyClass = 'js-accordion-body';
    var className = 'js-open';

    // titleごとに処理を実行
    $('.' + accordionTitleClass).each(function() {
        var $this = $(this);
        var $body = $this.nextAll('.' + accordionBodyClass);

        // あらかじめクラスが付いていたら初期表示でオープン
        if ($this.hasClass(className)) {
            $body.each( function() {
                $(this).show();
            });
        }

        // タイトルをクリックしたら開閉する
        $this.on('click', function() {
            $this.toggleClass(className);
            $body.each( function() {
                // $(this).toggleClass(className);
                $(this).slideToggle(250, 'linear');
            });
        });
    });
});
